import { GET_INDICATOR_DATA_SUCCESS } from '../actions/actionTypes';

interface IndicatorState {
  indicatorData: any;
}

const initialState: IndicatorState = {
  indicatorData: [],
};

const indicatorReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): IndicatorState => {
  switch (action.type) {
    case GET_INDICATOR_DATA_SUCCESS:
      return {
        ...state,
        indicatorData: action.payload?.Data ?? [],
      };

    default:
      return state;
  }
};

export default indicatorReducer;
